// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LM4C","badges":"styles_badges__2-Zly"};